import withStyles from 'material-ui/styles/withStyles'
import React from 'react'
import men_s_logo from 'sozai_sex_1.png'
import women_s_logo from 'sozai_sex_2.png'
import { get } from '../../modules/Api'
import styleSheet from './AllWebChatStyle.style'

class WebChatNewConsultation extends React.Component {
  state = {
    faqs: [],
  }

  componentDidMount() {
    get('/api/web_chat/top_faqs', (response) => {
      this.setState({
        faqs: response.data,
      })
    })
  }

  render() {
    const faqs = this.state.faqs
    const classes = this.props.classes

    return (
      <div className={classes.consult}>
        <div className={classes.consult_firstDiv}>
          <h3 className={classes.consult_title}>新着の相談</h3>
        </div>
        {faqs.map((faq) => (
          <div key={faq.id} className={classes.consult_secondDiv}>
            <p className={classes.consult_consultationContent}>
              <span className={classes.consult_Q}>Q</span>
              <a href={`/chat/faq_detail?chat_faq_id=${faq.id}`}>{faq.attributes.title}</a>
            </p>
            <div className={classes.consult_user}>
              {faq.attributes.user_sex == '男性' && <img className={classes.consult_img} src={men_s_logo} />}
              {faq.attributes.user_sex == '女性' && <img className={classes.consult_img} src={women_s_logo} />}
              {faq.attributes.age}代{faq.attributes.user_sex}
              <span className={classes.consult_answerDate}>回答日：{faq.attributes.answer_date}</span>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

export default withStyles(styleSheet)(WebChatNewConsultation)
